<template>
  <div class="description-list-item">
    <div class="description-list-item-term">{{ term }}</div>
    <div class="description-list-item-content" :style="contentStyle">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    term: String,
    contentStyle: {
      type: String
    }
  }
};
</script>
<style lang="less"></style>
